import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';
import React from 'react';

export const Wave = Styled(
	createSvgIcon(
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M3.34935 4.97508C2.29102 6.37508 1.66602 8.11675 1.66602 10.0001C1.66602 14.6001 5.39935 18.3334 9.99935 18.3334C14.5993 18.3334 18.3327 14.6001 18.3327 10.0001C18.3327 5.40008 14.5993 1.66675 9.99935 1.66675'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M4.16602 10.0001C4.16602 13.2251 6.77435 15.8334 9.99935 15.8334C13.2243 15.8334 15.8327 13.2251 15.8327 10.0001C15.8327 6.77508 13.2243 4.16675 9.99935 4.16675'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M10 13.3334C11.8417 13.3334 13.3333 11.8417 13.3333 10.0001C13.3333 8.15841 11.8417 6.66675 10 6.66675'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>,
		'Wave'
	)
);

export default Wave;
